export function hideHotjarWidget() {
  const widget = document.querySelector('._hj-widget-container') as HTMLElement;
  if (widget) widget.style.display = 'none';
}

export function showHotjarWidget() {
  const widget = document.querySelector('._hj-widget-container') as HTMLElement;
  if (widget) widget.style.display = '';
}